/* eslint-disable max-lines */
import BlanketQuiz from './blanketquiz.js';

const questionData = [
    {
        questionText:
            '<div class="header">We\'ll ask you up to 4 questions to find your perfect Turnout Blanket.<br>Let\'s get started!</div><br>How durable and tough does your turnout need to be?',
        name: 'Start',
        answers: [
            {
                response: "My horse goes out alone and/or doesn't roughhouse much.",
                link: 'Alone',
                image: ''
            },
            {
                response: 'My horse goes out with other horses and likes to play.',
                link: 'Playful',
                image: ''
            },
            {
                response: 'My horse is a certified blanket shredder!',
                link: 'Shredder',
                image: ''
            }
        ],
        products: false
    },
    {
        questionText: 'What body type does your horse have?',
        name: 'Alone',
        answers: [
            {
                response: 'Standard Body Type',
                link: 'Alone_Standard',
                image: '/images/BlanketQuiz/091918_PLTurnoutWizard_StandardBody.jpg'
            },
            {
                response: 'Quarter horse or stock horse body type',
                link: 'Alone_Quarter',
                image: '/images/BlanketQuiz/091918_PLTurnoutWizard_StockHorse.jpg'
            }
        ],
        products: false
    },
    {
        questionText: 'How warm of a turnout does your horse need?',
        name: 'Alone_Standard',
        answers: [
            {
                response: 'Sheet/Light (0g of fill)',
                link: 'Alone_Standard_Light',
                image: ''
            },
            {
                response: 'Medium (200-250g of fill)',
                link: 'Alone_Standard_Medium',
                image: ''
            },
            {
                response: 'Heavy (300g+ of fill)',
                link: 'Alone_Standard_Heavy',
                image: ''
            }
        ],
        products: false
    },
    {
        questionText: false,
        name: 'Alone_Standard_Light',
        answers: false,
        products: [23788]
    },
    {
        questionText: 'Which style neck would work best?',
        name: 'Alone_Standard_Medium',
        answers: [
            {
                response: 'Standard neck',
                link: 'Alone_Standard_Medium_StandardNeck',
                image: '/images/BlanketQuiz/091918_PLTurnoutWizard_StandardNeck.jpg'
            },
            {
                response: 'Attached neck rug',
                link: 'Alone_Standard_Medium_AttachedNeck',
                image: '/images/BlanketQuiz/091918_PLTurnoutWizard_NeckRug.jpg'
            }
        ],
        products: false
    },
    {
        questionText: false,
        name: 'Alone_Standard_Medium_StandardNeck',
        answers: false,
        products: [17374]
    },
    {
        questionText: false,
        name: 'Alone_Standard_Medium_AttachedNeck',
        answers: false,
        products: [27121]
    },
    {
        questionText: 'Which style neck would work best?',
        name: 'Alone_Standard_Heavy',
        answers: [
            {
                response: 'Standard neck',
                link: 'Alone_Standard_Heavy_StandardNeck',
                image: '/images/BlanketQuiz/091918_PLTurnoutWizard_StandardNeck.jpg'
            },
            {
                response: 'Attached neck rug',
                link: 'Alone_Standard_Heavy_AttachedNeck',
                image: '/images/BlanketQuiz/091918_PLTurnoutWizard_NeckRug.jpg'
            }
        ],
        products: false
    },
    {
        questionText: false,
        name: 'Alone_Standard_Heavy_StandardNeck',
        answers: false,
        products: [17374]
    },
    {
        questionText: false,
        name: 'Alone_Standard_Heavy_AttachedNeck',
        answers: false,
        products: [27121]
    },
    {
        questionText: 'How warm of a turnout does your horse need?',
        name: 'Alone_Quarter',
        answers: [
            {
                response: 'Sheet/Light (0g of fill)',
                link: 'Alone_Quarter_Light',
                image: ''
            },
            {
                response: 'Medium (200-250g of fill)',
                link: 'Alone_Quarter_Medium',
                image: ''
            },
            {
                response: 'Heavy (300g+ of fill)',
                link: 'Alone_Quarter_Heavy',
                image: ''
            }
        ],
        products: false
    },
    {
        questionText: false,
        name: 'Alone_Quarter_Light',
        answers: false,
        products: [23798]
    },
    {
        questionText: false,
        name: 'Alone_Quarter_Medium',
        answers: false,
        products: [21359]
    },
    {
        questionText: false,
        name: 'Alone_Quarter_Heavy',
        answers: false,
        products: [21359]
    },
    {
        questionText: 'What body type does your horse have?',
        name: 'Playful',
        answers: [
            {
                response: 'Standard Body Type',
                link: 'Playful_Standard',
                image: '/images/BlanketQuiz/091918_PLTurnoutWizard_StandardBody.jpg'
            },
            {
                response: 'Quarter horse or stock horse body type',
                link: 'Playful_Quarter',
                image: '/images/BlanketQuiz/091918_PLTurnoutWizard_StockHorse.jpg'
            }
        ],
        products: false
    },
    {
        questionText: 'How warm of a turnout does your horse need?',
        name: 'Playful_Standard',
        answers: [
            {
                response: 'Sheet/Light (0g of fill)',
                link: 'Playful_Standard_Light',
                image: ''
            },
            {
                response: 'Medium/Light (100g of fill)',
                link: 'Playful_Standard_MediumLight',
                image: ''
            },
            {
                response: 'Medium (200-250g of fill)',
                link: 'Playful_Standard_Medium',
                image: ''
            },
            {
                response: 'Heavy (300g+ of fill)',
                link: 'Playful_Standard_Heavy',
                image: ''
            }
        ],
        products: false
    },
    {
        questionText: 'Which style neck would work best?',
        name: 'Playful_Standard_Light',
        answers: [
            {
                response: 'Standard neck',
                link: 'Playful_Standard_Light_StandardNeck',
                image: '/images/BlanketQuiz/091918_PLTurnoutWizard_StandardNeck.jpg'
            },
            {
                response: 'High neck',
                link: 'Playful_Standard_Light_HighNeck',
                image: '/images/BlanketQuiz/091918_PLTurnoutWizard_HighNeck.jpg'
            },
            {
                response: 'Neck rug available (separate purchase)',
                link: 'Playful_Standard_Light_NeckRug',
                image: '/images/BlanketQuiz/091918_PLTurnoutWizard_NeckRug.jpg'
            }
        ],
        products: false
    },
    {
        questionText: false,
        name: 'Playful_Standard_Light_StandardNeck',
        answers: false,
        products: [23403]
    },
    {
        questionText: false,
        name: 'Playful_Standard_Light_HighNeck',
        answers: false,
        products: [23404]
    },
    {
        questionText: false,
        name: 'Playful_Standard_Light_NeckRug',
        answers: false,
        products: [23403, 17512]
    },
    {
        questionText: 'Which style neck would work best?',
        name: 'Playful_Standard_MediumLight',
        answers: [
            {
                response: 'Standard neck',
                link: 'Playful_Standard_MediumLight_StandardNeck',
                image: '/images/BlanketQuiz/091918_PLTurnoutWizard_StandardNeck.jpg'
            },
            {
                response: 'Neck rug available (separate purchase)',
                link: 'Playful_Standard_MediumLight_NeckRug',
                image: '/images/BlanketQuiz/091918_PLTurnoutWizard_NeckRug.jpg'
            }
        ],
        products: false
    },
    {
        questionText: false,
        name: 'Playful_Standard_MediumLight_StandardNeck',
        answers: false,
        products: [17376]
    },
    {
        questionText: false,
        name: 'Playful_Standard_MediumLight_NeckRug',
        answers: false,
        products: [17376, 17512]
    },
    {
        questionText: 'Which style neck would work best?',
        name: 'Playful_Standard_Medium',
        answers: [
            {
                response: 'Standard neck',
                link: 'Playful_Standard_Medium_StandardNeck',
                image: '/images/BlanketQuiz/091918_PLTurnoutWizard_StandardNeck.jpg'
            },
            {
                response: 'High neck',
                link: 'Playful_Standard_Medium_HighNeck',
                image: '/images/BlanketQuiz/091918_PLTurnoutWizard_HighNeck.jpg'
            },
            {
                response: 'Neck rug available (separate purchase)',
                link: 'Playful_Standard_Medium_NeckRug',
                image: '/images/BlanketQuiz/091918_PLTurnoutWizard_NeckRug.jpg'
            }
        ],
        products: false
    },
    {
        questionText: false,
        name: 'Playful_Standard_Medium_StandardNeck',
        answers: false,
        products: [17376]
    },
    {
        questionText: false,
        name: 'Playful_Standard_Medium_HighNeck',
        answers: false,
        products: [17378]
    },
    {
        questionText: false,
        name: 'Playful_Standard_Medium_NeckRug',
        answers: false,
        products: [17376, 17512]
    },
    {
        questionText: 'Which style neck would work best?',
        name: 'Playful_Standard_Heavy',
        answers: [
            {
                response: 'Standard neck',
                link: 'Playful_Standard_Heavy_StandardNeck',
                image: '/images/BlanketQuiz/091918_PLTurnoutWizard_StandardNeck.jpg'
            },
            {
                response: 'High neck',
                link: 'Playful_Standard_Heavy_HighNeck',
                image: '/images/BlanketQuiz/091918_PLTurnoutWizard_HighNeck.jpg'
            },
            {
                response: 'Neck rug available (separate purchase)',
                link: 'Playful_Standard_Heavy_NeckRug',
                image: '/images/BlanketQuiz/091918_PLTurnoutWizard_NeckRug.jpg'
            }
        ],
        products: false
    },
    {
        questionText: false,
        name: 'Playful_Standard_Heavy_StandardNeck',
        answers: false,
        products: [17376]
    },
    {
        questionText: false,
        name: 'Playful_Standard_Heavy_HighNeck',
        answers: false,
        products: [17378]
    },
    {
        questionText: false,
        name: 'Playful_Standard_Heavy_NeckRug',
        answers: false,
        products: [17376, 17512]
    },
    {
        questionText: 'How warm of a turnout does your horse need?',
        name: 'Playful_Quarter',
        answers: [
            {
                response: 'Sheet/Light (0g of fill)',
                link: 'Playful_Quarter_Light',
                image: ''
            },
            {
                response: 'Medium (200-250g of fill)',
                link: 'Playful_Quarter_Medium',
                image: ''
            },
            {
                response: 'Heavy (300g+ of fill)',
                link: 'Playful_Quarter_Heavy',
                image: ''
            }
        ],
        products: false
    },
    {
        questionText: 'Which style neck would work best?',
        name: 'Playful_Quarter_Light',
        answers: [
            {
                response: 'Standard neck',
                link: 'Playful_Quarter_Light_StandardNeck',
                image: '/images/BlanketQuiz/091918_PLTurnoutWizard_StandardNeck.jpg'
            },
            {
                response: 'Neck rug available (separate purchase)',
                link: 'Playful_Quarter_Light_NeckRug',
                image: '/images/BlanketQuiz/091918_PLTurnoutWizard_NeckRug.jpg'
            }
        ],
        products: false
    },
    {
        questionText: false,
        name: 'Playful_Quarter_Light_StandardNeck',
        answers: false,
        products: [23797]
    },
    {
        questionText: false,
        name: 'Playful_Quarter_Light_NeckRug',
        answers: false,
        products: [23797, 21362]
    },
    {
        questionText: 'Which style neck would work best?',
        name: 'Playful_Quarter_Medium',
        answers: [
            {
                response: 'Standard neck',
                link: 'Playful_Quarter_Medium_StandardNeck',
                image: '/images/BlanketQuiz/091918_PLTurnoutWizard_StandardNeck.jpg'
            },
            {
                response: 'Neck rug available (separate purchase)',
                link: 'Playful_Quarter_Medium_NeckRug',
                image: '/images/BlanketQuiz/091918_PLTurnoutWizard_NeckRug.jpg'
            }
        ],
        products: false
    },
    {
        questionText: false,
        name: 'Playful_Quarter_Medium_StandardNeck',
        answers: false,
        products: [21356]
    },
    {
        questionText: false,
        name: 'Playful_Quarter_Medium_NeckRug',
        answers: false,
        products: [21356, 21362]
    },
    {
        questionText: 'Which style neck would work best?',
        name: 'Playful_Quarter_Heavy',
        answers: [
            {
                response: 'Standard neck',
                link: 'Playful_Quarter_Heavy_StandardNeck',
                image: '/images/BlanketQuiz/091918_PLTurnoutWizard_StandardNeck.jpg'
            },
            {
                response: 'Neck rug available (separate purchase)',
                link: 'Playful_Quarter_Heavy_NeckRug',
                image: '/images/BlanketQuiz/091918_PLTurnoutWizard_NeckRug.jpg'
            }
        ],
        products: false
    },
    {
        questionText: false,
        name: 'Playful_Quarter_Heavy_StandardNeck',
        answers: false,
        products: [21356]
    },
    {
        questionText: false,
        name: 'Playful_Quarter_Heavy_NeckRug',
        answers: false,
        products: [21356, 21362]
    },
    {
        questionText: 'What body type does your horse have?',
        name: 'Shredder',
        answers: [
            {
                response: 'Standard Body Type',
                link: 'Shredder_Standard',
                image: '/images/BlanketQuiz/091918_PLTurnoutWizard_StandardBody.jpg'
            },
            {
                response: 'Quarter horse or stock horse body type',
                link: 'Shredder_Quarter',
                image: '/images/BlanketQuiz/091918_PLTurnoutWizard_StockHorse.jpg'
            }
        ],
        products: false
    },
    {
        questionText: 'How warm of a turnout does your horse need?',
        name: 'Shredder_Standard',
        answers: [
            {
                response: 'Sheet/Light (0g of fill)',
                link: 'Shredder_Standard_Light',
                image: ''
            },
            {
                response: 'Medium/Light (150g of fill)',
                link: 'Shredder_Standard_MediumLight',
                image: ''
            },
            {
                response: 'Medium (200-250g of fill)',
                link: 'Shredder_Standard_Medium',
                image: ''
            },
            {
                response: 'Heavy (300g+ of fill)',
                link: 'Shredder_Standard_Heavy',
                image: ''
            }
        ],
        products: false
    },
    {
        questionText: 'Which style neck would work best?',
        name: 'Shredder_Standard_Light',
        answers: [
            {
                response: 'Standard neck',
                link: 'Shredder_Standard_Light_StandardNeck',
                image: '/images/BlanketQuiz/091918_PLTurnoutWizard_StandardNeck.jpg'
            },
            {
                response: 'High neck',
                link: 'Shredder_Standard_Light_HighNeck',
                image: '/images/BlanketQuiz/091918_PLTurnoutWizard_HighNeck.jpg'
            },
            {
                response: 'Attached neck rug',
                link: 'Shredder_Standard_Light_AttachedNeck',
                image: '/images/BlanketQuiz/091918_PLTurnoutWizard_AttachedNeck.jpg'
            },
            {
                response: 'Neck rug available (separate purchase)',
                link: 'Shredder_Standard_Light_NeckRug',
                image: '/images/BlanketQuiz/091918_PLTurnoutWizard_NeckRug.jpg'
            }
        ],
        products: false
    },
    {
        questionText: false,
        name: 'Shredder_Standard_Light_StandardNeck',
        answers: false,
        products: [23405, 27112]
    },
    {
        questionText: false,
        name: 'Shredder_Standard_Light_HighNeck',
        answers: false,
        products: [23407, 27113]
    },
    {
        questionText: false,
        name: 'Shredder_Standard_Light_AttachedNeck',
        answers: false,
        products: [24912]
    },
    {
        questionText: false,
        name: 'Shredder_Standard_Light_NeckRug',
        answers: false,
        products: [23405, 21211]
    },
    {
        questionText: false,
        name: 'Shredder_Standard_MediumLight',
        answers: false,
        products: [27115]
    },
    {
        questionText: 'Which style neck would work best?',
        name: 'Shredder_Standard_Medium',
        answers: [
            {
                response: 'Standard neck',
                link: 'Shredder_Standard_Medium_StandardNeck',
                image: '/images/BlanketQuiz/091918_PLTurnoutWizard_StandardNeck.jpg'
            },
            {
                response: 'High neck',
                link: 'Shredder_Standard_Medium_HighNeck',
                image: '/images/BlanketQuiz/091918_PLTurnoutWizard_HighNeck.jpg'
            },
            {
                response: 'Attached neck rug',
                link: 'Shredder_Standard_Medium_AttachedNeck',
                image: '/images/BlanketQuiz/091918_PLTurnoutWizard_AttachedNeck.jpg'
            },
            {
                response: 'Neck rug available (separate purchase)',
                link: 'Shredder_Standard_Medium_NeckRug',
                image: '/images/BlanketQuiz/091918_PLTurnoutWizard_NeckRug.jpg'
            }
        ],
        products: false
    },
    {
        questionText: false,
        name: 'Shredder_Standard_Medium_StandardNeck',
        answers: false,
        products: [20621, 27114]
    },
    {
        questionText: false,
        name: 'Shredder_Standard_Medium_HighNeck',
        answers: false,
        products: [22570, 27115]
    },
    {
        questionText: false,
        name: 'Shredder_Standard_Medium_AttachedNeck',
        answers: false,
        products: [22569]
    },
    {
        questionText: false,
        name: 'Shredder_Standard_Medium_NeckRug',
        answers: false,
        products: [20621, 21211]
    },
    {
        questionText: 'Which style neck would work best?',
        name: 'Shredder_Standard_Heavy',
        answers: [
            {
                response: 'Standard neck',
                link: 'Shredder_Standard_Heavy_StandardNeck',
                image: '/images/BlanketQuiz/091918_PLTurnoutWizard_StandardNeck.jpg'
            },
            {
                response: 'High neck',
                link: 'Shredder_Standard_Heavy_HighNeck',
                image: '/images/BlanketQuiz/091918_PLTurnoutWizard_HighNeck.jpg'
            },
            {
                response: 'Attached neck rug',
                link: 'Shredder_Standard_Heavy_AttachedNeck',
                image: '/images/BlanketQuiz/091918_PLTurnoutWizard_AttachedNeck.jpg'
            },
            {
                response: 'Neck rug available (separate purchase)',
                link: 'Shredder_Standard_Heavy_NeckRug',
                image: '/images/BlanketQuiz/091918_PLTurnoutWizard_NeckRug.jpg'
            }
        ],
        products: false
    },
    {
        questionText: false,
        name: 'Shredder_Standard_Heavy_StandardNeck',
        answers: false,
        products: [20621, 27114]
    },
    {
        questionText: false,
        name: 'Shredder_Standard_Heavy_HighNeck',
        answers: false,
        products: [22570]
    },
    {
        questionText: false,
        name: 'Shredder_Standard_Heavy_AttachedNeck',
        answers: false,
        products: [22569]
    },
    {
        questionText: false,
        name: 'Shredder_Standard_Heavy_NeckRug',
        answers: false,
        products: [20621, 27114, 21211]
    },
    {
        questionText: 'How warm of a turnout does your horse need?',
        name: 'Shredder_Quarter',
        answers: [
            {
                response: 'Sheet/Light (0g of fill)',
                link: 'Shredder_Quarter_Light',
                image: ''
            },
            {
                response: 'Medium (200-250g of fill)',
                link: 'Shredder_Quarter_Medium',
                image: ''
            },
            {
                response: 'Heavy (300g+ of fill)',
                link: 'Shredder_Quarter_Heavy',
                image: ''
            }
        ],
        products: false
    },
    {
        questionText: 'Which style neck would work best?',
        name: 'Shredder_Quarter_Light',
        answers: [
            {
                response: 'Standard neck',
                link: 'Shredder_Quarter_Light_StandardNeck',
                image: '/images/BlanketQuiz/091918_PLTurnoutWizard_StandardNeck.jpg'
            },
            {
                response: 'High neck',
                link: 'Shredder_Quarter_Light_HighNeck',
                image: '/images/BlanketQuiz/091918_PLTurnoutWizard_HighNeck.jpg'
            },
            {
                response: 'Neck rug available (separate purchase)',
                link: 'Shredder_Quarter_Light_NeckRug',
                image: '/images/BlanketQuiz/091918_PLTurnoutWizard_NeckRug.jpg'
            }
        ],
        products: false
    },
    {
        questionText: false,
        name: 'Shredder_Quarter_Light_StandardNeck',
        answers: false,
        products: [23408]
    },
    {
        questionText: false,
        name: 'Shredder_Quarter_Light_HighNeck',
        answers: false,
        products: [24821]
    },
    {
        questionText: false,
        name: 'Shredder_Quarter_Light_NeckRug',
        answers: false,
        products: [23408, 21893]
    },
    {
        questionText: 'Which style neck would work best?',
        name: 'Shredder_Quarter_Medium',
        answers: [
            {
                response: 'Standard neck',
                link: 'Shredder_Quarter_Medium_StandardNeck',
                image: '/images/BlanketQuiz/091918_PLTurnoutWizard_StandardNeck.jpg'
            },
            {
                response: 'High neck',
                link: 'Shredder_Quarter_Medium_HighNeck',
                image: '/images/BlanketQuiz/091918_PLTurnoutWizard_HighNeck.jpg'
            },
            {
                response: 'Neck rug available (separate purchase)',
                link: 'Shredder_Quarter_Medium_NeckRug',
                image: '/images/BlanketQuiz/091918_PLTurnoutWizard_NeckRug.jpg'
            }
        ],
        products: false
    },
    {
        questionText: false,
        name: 'Shredder_Quarter_Medium_StandardNeck',
        answers: false,
        products: [21871]
    },
    {
        questionText: false,
        name: 'Shredder_Quarter_Medium_HighNeck',
        answers: false,
        products: [24820]
    },
    {
        questionText: false,
        name: 'Shredder_Quarter_Medium_NeckRug',
        answers: false,
        products: [21871, 21893]
    },
    {
        questionText: 'Which style neck would work best?',
        name: 'Shredder_Quarter_Heavy',
        answers: [
            {
                response: 'Standard neck',
                link: 'Shredder_Quarter_Heavy_StandardNeck',
                image: '/images/BlanketQuiz/091918_PLTurnoutWizard_StandardNeck.jpg'
            },
            {
                response: 'High neck',
                link: 'Shredder_Quarter_Heavy_HighNeck',
                image: '/images/BlanketQuiz/091918_PLTurnoutWizard_HighNeck.jpg'
            },
            {
                response: 'Neck rug available (separate purchase)',
                link: 'Shredder_Quarter_Heavy_NeckRug',
                image: '/images/BlanketQuiz/091918_PLTurnoutWizard_NeckRug.jpg'
            }
        ],
        products: false
    },
    {
        questionText: false,
        name: 'Shredder_Quarter_Heavy_StandardNeck',
        answers: false,
        products: [21871]
    },
    {
        questionText: false,
        name: 'Shredder_Quarter_Heavy_HighNeck',
        answers: false,
        products: [24820]
    },
    {
        questionText: false,
        name: 'Shredder_Quarter_Heavy_NeckRug',
        answers: false,
        products: [21871, 21893]
    }
];

window.addEventListener('DOMContentLoaded', function() {
    ko.applyBindings(new BlanketQuiz(questionData), document.getElementById('blanketQuiz'));
});
